/* lua.js generated code 0.3.0 */

require("clover/config/LocalDataConfig")
UserLocalSettings = {}
UserLocalSettings.getSetting = function (key, defaultValue) {
    var self = this
    var settings = self.readFromFile()
    // cc.log("settings", table.tostring(settings))
    if (settings[key]) {
        return type(defaultValue) === "number" ? tonumber(settings[key]) : settings[key]
    } else {
        return defaultValue
    }
}
UserLocalSettings.setSetting = function (key, value) {
    var self = this
    var settings = self.readFromFile()
    settings[key] = value
    self.flushToStorage(settings)
}
UserLocalSettings.removeSetting = function (key) {
    var self = this
    var settings = self.readFromFile()
    settings[key] = null
    self.flushToStorage(settings)
}

// FIXME: !
UserLocalSettings.readFromFile = function () {
    // return Persistence.readFileData(LocalDataFiles.kLocalSettings) || table()
    let value = cc.UserDefault.getInstance().getStringForKey(LOCAL_SETTING_KEY)
    try {
        value = JSON.parse(value)
    } catch (error) {
        value = {}
    }
    return value
}
UserLocalSettings.flushToStorage = function (data) {
    // Persistence.writeFileData(data, LocalDataFiles.kLocalSettings)
    cc.UserDefault.getInstance().setStringForKey(LOCAL_SETTING_KEY, JSON.stringify(data))
    return 
}
UserLocalSettings.transfer = function (oldSrcData, newSrcData) {
    cc.log("UserLocalSettings:transfer", table.tostring(oldSrcData), table.tostring(newSrcData))
    // WARN: maybe multi result
    return table.merge(newSrcData || table(), oldSrcData || table())
}
